
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("4CscR", function(module, exports) {

$parcel$export(module.exports, "getGlobalErrorCount", () => $bec317d59f8c4a12$export$d06c0426664e7c08);
$parcel$export(module.exports, "default", () => $bec317d59f8c4a12$export$2e2bcd8739ae039);

var $cBeZP = parcelRequire("cBeZP");
let $bec317d59f8c4a12$var$shouldInitilizeGlobalErrorHandler = true;
let $bec317d59f8c4a12$var$globalCount = 0;
const $bec317d59f8c4a12$var$errors = [];
let $bec317d59f8c4a12$var$push = (name, labelStack, errorType, errorMessage, errorStack)=>{
    $bec317d59f8c4a12$var$errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
};
function $bec317d59f8c4a12$export$ebe081a8c9bf8176(sinkFunc) {
    $bec317d59f8c4a12$var$push = sinkFunc;
    $bec317d59f8c4a12$var$errors.forEach((e)=>{
        sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
    });
    $bec317d59f8c4a12$var$errors.length = 0;
}
function $bec317d59f8c4a12$export$d06c0426664e7c08() {
    return $bec317d59f8c4a12$var$globalCount;
}
function $bec317d59f8c4a12$var$handleError(e) {
    $bec317d59f8c4a12$var$globalCount++;
    if (e.error?.UFOhasCaught === undefined) try {
        if (e.error instanceof Error) $bec317d59f8c4a12$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
        else if (e.error) {
            const hint = JSON.stringify(e.error).slice(0, 50);
            $bec317d59f8c4a12$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        } else if (e.message !== undefined) {
            const hint = e.message.slice(0, 50);
            $bec317d59f8c4a12$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        }
        if (e.error && typeof e.error === 'object') e.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch (e) {}
}
function $bec317d59f8c4a12$var$handlePromiseRejection(e) {
    $bec317d59f8c4a12$var$globalCount++;
    if (e.reason instanceof Error) $bec317d59f8c4a12$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
    else if (e.reason) try {
        const hint = JSON.stringify(e.reason).slice(0, 50);
        $bec317d59f8c4a12$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
    // eslint-disable-next-line no-empty
    } catch (e) {}
}
function $bec317d59f8c4a12$var$setupUFOGlobalErrorHandler() {
    if ($bec317d59f8c4a12$var$shouldInitilizeGlobalErrorHandler) {
        (0, $cBeZP.bind)(window, {
            type: 'error',
            listener: (e)=>$bec317d59f8c4a12$var$handleError(e)
        });
        (0, $cBeZP.bind)(window, {
            type: 'unhandledrejection',
            listener: $bec317d59f8c4a12$var$handlePromiseRejection
        });
        $bec317d59f8c4a12$var$shouldInitilizeGlobalErrorHandler = false;
    }
}
var $bec317d59f8c4a12$export$2e2bcd8739ae039 = $bec317d59f8c4a12$var$setupUFOGlobalErrorHandler;

});

parcelRegister("baR7z", function(module, exports) {

$parcel$export(module.exports, "reportError", () => $0857c463006e50d7$export$b33b857ad1d9900e);
$parcel$export(module.exports, "installErrorHandler", () => $0857c463006e50d7$export$abd5747ea77ecab9);

var $hFKXd = parcelRequire("hFKXd");
const $0857c463006e50d7$var$buffer = [];
let $0857c463006e50d7$var$push = (payload)=>{
    $0857c463006e50d7$var$buffer.push(payload);
};
function $0857c463006e50d7$export$b33b857ad1d9900e(payload) {
    $0857c463006e50d7$var$push(payload);
}
function $0857c463006e50d7$export$abd5747ea77ecab9(handler) {
    if ((0, $hFKXd.fg)('moving_jira_entry-points_api_under_platform')) {
        $0857c463006e50d7$var$push = handler;
        $0857c463006e50d7$var$buffer.forEach((payload)=>handler(payload));
        $0857c463006e50d7$var$buffer.length = 0;
    }
}

});

parcelRegister("khUYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a035d020e42876$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useInteractionContext", () => $b0a035d020e42876$export$11bcb6e9af2aca35);

var $5uXOq = parcelRequire("5uXOq");

var $kljwF = parcelRequire("kljwF");
var $b0a035d020e42876$export$2e2bcd8739ae039 = (0, $kljwF.default);
function $b0a035d020e42876$export$11bcb6e9af2aca35() {
    return (0, $5uXOq.useContext)((0, $kljwF.default));
}

});

parcelRegister("gWHEk", function(module, exports) {

$parcel$export(module.exports, "browserMetrics", () => $ec775f2d3f841ba8$export$c08e7affcf78b064);

var $iKOfJ = parcelRequire("iKOfJ");

var $7aLI7 = parcelRequire("7aLI7");

var $9EfFg = parcelRequire("9EfFg");

var $gm6y9 = parcelRequire("gm6y9");

var $ijz4N = parcelRequire("ijz4N");

var $5mgZQ = parcelRequire("5mgZQ");

var $86O1L = parcelRequire("86O1L");

var $4pWCS = parcelRequire("4pWCS");
const $ec775f2d3f841ba8$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            (0, $gm6y9.visibilityChangeObserver).start();
            if (config.events[(0, $4pWCS.BMEventsType).WEB_VITALS]?.enabled) (0, $ijz4N.webVitalsObserver).start();
            if (config.debug) {
                (0, $7aLI7.logger).enable();
                (0, $86O1L.submitter).setDebug(true);
                (0, $9EfFg.pageLoadMetaMetric).setDebug(true);
            }
            (0, $86O1L.submitter).configure(config);
            if (config.ssr?.getDoneMark) (0, $iKOfJ.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $5mgZQ.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $9EfFg.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $9EfFg.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $9EfFg.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $9EfFg.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $9EfFg.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $9EfFg.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $ec775f2d3f841ba8$export$c08e7affcf78b064 = $ec775f2d3f841ba8$var$makeBrowserMetrics();

});
parcelRegister("iKOfJ", function(module, exports) {

$parcel$export(module.exports, "SSRGetDoneMark", () => $6cdd6ccc9f0fcca1$export$9e87a201397ac0a9);
const $6cdd6ccc9f0fcca1$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $6cdd6ccc9f0fcca1$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("7aLI7", function(module, exports) {

$parcel$export(module.exports, "logger", () => $07cc83298b62e788$export$af88d00dbe7f521);
const $07cc83298b62e788$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("9EfFg", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetaMetric", () => $e4a860d5fb8b5927$export$24b7a1a311eb05dc);

var $4pWCS = parcelRequire("4pWCS");

var $c4cEO = parcelRequire("c4cEO");

var $5SZk3 = parcelRequire("5SZk3");
class $e4a860d5fb8b5927$export$9609608c00ea5077 extends (0, $5SZk3.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $c4cEO.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args), this.activePageLoadMetric = null;
    }
}
const $e4a860d5fb8b5927$export$24b7a1a311eb05dc = new $e4a860d5fb8b5927$export$9609608c00ea5077({
    type: (0, $4pWCS.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("4pWCS", function(module, exports) {

$parcel$export(module.exports, "BMEventsType", () => $94d2da1cf3aa4556$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $94d2da1cf3aa4556$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $94d2da1cf3aa4556$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $94d2da1cf3aa4556$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $94d2da1cf3aa4556$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $94d2da1cf3aa4556$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $94d2da1cf3aa4556$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $94d2da1cf3aa4556$export$983b017156c2aee2);
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $94d2da1cf3aa4556$export$5866f95702a15142);
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $94d2da1cf3aa4556$export$f087a59bd717e49d);
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $94d2da1cf3aa4556$export$b10c1d9a7db7765b);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $94d2da1cf3aa4556$export$60c0193054fc3040);

var $c4cEO = parcelRequire("c4cEO");
var $94d2da1cf3aa4556$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $94d2da1cf3aa4556$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $94d2da1cf3aa4556$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $94d2da1cf3aa4556$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $94d2da1cf3aa4556$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $94d2da1cf3aa4556$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $94d2da1cf3aa4556$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $94d2da1cf3aa4556$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
const $94d2da1cf3aa4556$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};
const $94d2da1cf3aa4556$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};
const $94d2da1cf3aa4556$export$153c4c72fa5eeece = (data)=>{
    const obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
const $94d2da1cf3aa4556$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $94d2da1cf3aa4556$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("c4cEO", function(module, exports) {

$parcel$export(module.exports, "MetricState", () => $06b77ad9a418eea3$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $06b77ad9a418eea3$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $06b77ad9a418eea3$export$2bce4ffdd840e878);

var $aYK1g = parcelRequire("aYK1g");

var $7aLI7 = parcelRequire("7aLI7");

var $gm6y9 = parcelRequire("gm6y9");

var $kWNZE = parcelRequire("kWNZE");
var $06b77ad9a418eea3$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $06b77ad9a418eea3$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $06b77ad9a418eea3$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $06b77ad9a418eea3$export$2bce4ffdd840e878 {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $06b77ad9a418eea3$var$getPageVisibleState();
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        this.config.timings?.forEach((entry)=>{
            if ((0, $aYK1g.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $7aLI7.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $06b77ad9a418eea3$var$getPageVisibleState();
        (0, $gm6y9.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $7aLI7.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $7aLI7.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $gm6y9.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return true;
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $7aLI7.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $gm6y9.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
	 *
	 * @param metric
	 * The array of Until metrics can be of two types
	 * This function returns an UntilExperience
	 */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $06b77ad9a418eea3$export$2bce4ffdd840e878 ? (0, $kWNZE.UntilExperience).fromMetric(metricOrConfig) : (0, $kWNZE.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = currentLatestSegment?.getFullyInteractiveStopTime() ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment?.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment?.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $06b77ad9a418eea3$var$getPageVisibleState();
    }
}

});
parcelRegister("aYK1g", function(module, exports) {

$parcel$export(module.exports, "restrictedTimingKeys", () => $da083aab38f1adf9$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $da083aab38f1adf9$export$df21d285cfcda81e);
const $da083aab38f1adf9$export$1d17377365286b00 = [
    'ssr'
];
const $da083aab38f1adf9$export$df21d285cfcda81e = 7500;

});

parcelRegister("gm6y9", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $1b281cb9665bc5a4$export$13e680397ec8f3eb);
class $1b281cb9665bc5a4$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $1b281cb9665bc5a4$export$13e680397ec8f3eb = new $1b281cb9665bc5a4$var$VisibilityChangeObserver();

});

parcelRegister("kWNZE", function(module, exports) {

$parcel$export(module.exports, "UntilExperience", () => $917f1801f2bab9d6$export$3fcc0936ee2cc852);
class $917f1801f2bab9d6$export$3fcc0936ee2cc852 {
    static{
        this.FMP = 'fmp';
    }
    static fromConfig(config) {
        return new $917f1801f2bab9d6$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $917f1801f2bab9d6$export$3fcc0936ee2cc852(metric);
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
	 * If FMP mark is present, return that
	 * otherwise return the eventual load
	 */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$917f1801f2bab9d6$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
	 * Get the time it takes for a segment to become fully interactable,
	 * regardless of whether it uses the FMP as the stop time. (Eventual load)
	 */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$917f1801f2bab9d6$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
}

});



parcelRegister("5SZk3", function(module, exports) {

$parcel$export(module.exports, "BasePageLoadMetric", () => $4ccd3d35cb1dd6bb$export$fd1447b187f590fe);

var $7aLI7 = parcelRequire("7aLI7");

var $c4cEO = parcelRequire("c4cEO");
class $4ccd3d35cb1dd6bb$export$fd1447b187f590fe extends (0, $c4cEO.BaseMetric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(args){
        super(args), this.isInitial = true, this.explicitTimings = null;
        this.config = args;
    }
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $7aLI7.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $c4cEO.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $7aLI7.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $7aLI7.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $c4cEO.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $4ccd3d35cb1dd6bb$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4ccd3d35cb1dd6bb$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($4ccd3d35cb1dd6bb$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
}

});


parcelRegister("ijz4N", function(module, exports) {

$parcel$export(module.exports, "webVitalsObserver", () => $911afa5be5ef2aa5$export$253d38dccbb37615);


class $911afa5be5ef2aa5$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("ivBtU"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("ksDQH"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $911afa5be5ef2aa5$export$253d38dccbb37615 = new $911afa5be5ef2aa5$var$WebVitalsObserver();

});
parcelRegister("ivBtU", function(module, exports) {

let $d7983245bb44640c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d7983245bb44640c$var$load("Gxk7c").then(()=>parcelRequire('gDSxx'));

});
parcelRegister("28QjX", function(module, exports) {
"use strict";


let $18f4e9fbd43d4c3b$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve(id), maxShards));
    };
module.exports = $18f4e9fbd43d4c3b$var$load;

});
parcelRegister("kPuw4", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2, (v) => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f2a03df3e93d4e79$export$2bf9932c19d6a5d2;
var $f2a03df3e93d4e79$export$1d37a31d51d1e3ed;
var $f2a03df3e93d4e79$export$b4cd98d62f81485f;
var $f2a03df3e93d4e79$export$108ff8fc702e621f;
var $f2a03df3e93d4e79$export$f6f4188f9108e61;
"use strict";
let $f2a03df3e93d4e79$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $f2a03df3e93d4e79$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $f2a03df3e93d4e79$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $f2a03df3e93d4e79$var$removeTrailingShard(subdomain) {
    if (!$f2a03df3e93d4e79$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $f2a03df3e93d4e79$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$f2a03df3e93d4e79$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $f2a03df3e93d4e79$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $f2a03df3e93d4e79$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $f2a03df3e93d4e79$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $f2a03df3e93d4e79$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$f2a03df3e93d4e79$var$globalKeyName]) return url;
    return $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards);
}
$f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = $f2a03df3e93d4e79$var$shardUrl;
$f2a03df3e93d4e79$export$1d37a31d51d1e3ed = $f2a03df3e93d4e79$var$shardUrlUnchecked;
$f2a03df3e93d4e79$export$b4cd98d62f81485f = $f2a03df3e93d4e79$var$getDomainShardIndex;
$f2a03df3e93d4e79$export$108ff8fc702e621f = $f2a03df3e93d4e79$var$applyShardToDomain;
$f2a03df3e93d4e79$export$f6f4188f9108e61 = $f2a03df3e93d4e79$var$globalKeyName;

});

parcelRegister("dy9lH", function(module, exports) {

$parcel$export(module.exports, "register", () => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v) => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v) => $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
"use strict";
var $9dd5b3e06d7b5702$var$mapping = new Map();
function $9dd5b3e06d7b5702$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9dd5b3e06d7b5702$var$resolve(id) {
    var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;

});



parcelRegister("ksDQH", function(module, exports) {

let $ee555554a2c242d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee555554a2c242d0$var$load("14BJH").then(()=>parcelRequire('8yzun'));

});


parcelRegister("5mgZQ", function(module, exports) {

$parcel$export(module.exports, "Route", () => $dab7c505fdca3bc6$export$e7b0ac011bb776c6);
const $dab7c505fdca3bc6$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("86O1L", function(module, exports) {

$parcel$export(module.exports, "submitter", () => $61233bb660950f8b$export$c21a25872e3f5a2b);

var $7E9G2 = parcelRequire("7E9G2");

var $4pWCS = parcelRequire("4pWCS");

var $gkOQF = parcelRequire("gkOQF");

var $iaf4x = parcelRequire("iaf4x");
const $61233bb660950f8b$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $iaf4x.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $4pWCS.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $7E9G2.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $gkOQF.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
    }
};

});
parcelRegister("gkOQF", function(module, exports) {

$parcel$export(module.exports, "eventDataProcessor", () => $636bb42aae64c21e$export$896b6e121bbaec25);

var $aYK1g = parcelRequire("aYK1g");

var $7aLI7 = parcelRequire("7aLI7");

var $1wjYt = parcelRequire("1wjYt");

var $37Uoz = parcelRequire("37Uoz");

var $bjQ1n = parcelRequire("bjQ1n");

var $bLJ7U = parcelRequire("bLJ7U");

var $gKKg0 = parcelRequire("gKKg0");

var $bSYcP = parcelRequire("bSYcP");

var $dCIsG = parcelRequire("dCIsG");

var $jAlk0 = parcelRequire("jAlk0");

var $SgPTv = parcelRequire("SgPTv");

var $3H6M8 = parcelRequire("3H6M8");

var $dOcKt = parcelRequire("dOcKt");

var $kKTdf = parcelRequire("kKTdf");

var $i73iw = parcelRequire("i73iw");

var $cZQQm = parcelRequire("cZQQm");

var $7KbFk = parcelRequire("7KbFk");

var $gMSq9 = parcelRequire("gMSq9");

var $48rs6 = parcelRequire("48rs6");

var $5z4jj = parcelRequire("5z4jj");

var $7Etaq = parcelRequire("7Etaq");

var $2jaQ3 = parcelRequire("2jaQ3");

var $daEdN = parcelRequire("daEdN");

var $2zJKD = parcelRequire("2zJKD");

var $dnamH = parcelRequire("dnamH");

var $k5i61 = parcelRequire("k5i61");

var $6Dxf3 = parcelRequire("6Dxf3");

var $9b69F = parcelRequire("9b69F");

var $dE6Wc = parcelRequire("dE6Wc");

var $b87QT = parcelRequire("b87QT");

var $6ZQkL = parcelRequire("6ZQkL");

var $87NA1 = parcelRequire("87NA1");

var $1p0BT = parcelRequire("1p0BT");

var $bFBnq = parcelRequire("bFBnq");

var $4tc5v = parcelRequire("4tc5v");

var $5IjYB = parcelRequire("5IjYB");

var $4pWCS = parcelRequire("4pWCS");
const $636bb42aae64c21e$var$defaultSet = [
    (0, $jAlk0.eventKey),
    (0, $i73iw.eventType),
    (0, $3H6M8.eventProduct),
    (0, $kKTdf.eventRoute),
    (0, $bSYcP.eventId),
    (0, $SgPTv.eventLocalTime),
    (0, $dOcKt.eventRegion),
    (0, $37Uoz.appFramework),
    (0, $bjQ1n.appVersion),
    (0, $bLJ7U.bmVersion),
    (0, $b87QT.telemetryBrowser),
    (0, $6ZQkL.telemetryCpu),
    (0, $87NA1.telemetryMemory),
    (0, $1p0BT.telemetryNetwork),
    (0, $gKKg0.customData),
    (0, $cZQQm.featureFlags),
    (0, $7KbFk.hostname),
    (0, $6Dxf3.productCustomData),
    (0, $bFBnq.appTimings),
    (0, $5IjYB.resourceTimings)
];
const $636bb42aae64c21e$var$pageLoadCommon = [
    ...$636bb42aae64c21e$var$defaultSet,
    (0, $dnamH.pageVisibleState),
    (0, $k5i61.pageVisibleValue),
    (0, $dCIsG.eventInitial),
    (0, $2jaQ3.pageLoadMetrics),
    (0, $4tc5v.bundleEvalTimings)
];
const $636bb42aae64c21e$var$initialPageLoadSet = [
    ...$636bb42aae64c21e$var$pageLoadCommon,
    (0, $48rs6.initialPageLoadMetrics),
    (0, $7Etaq.navigationMetrics),
    (0, $dE6Wc.ssrSuccess),
    (0, $9b69F.ssrFeatureFlags)
];
const $636bb42aae64c21e$var$spaTransitionSet = [
    ...$636bb42aae64c21e$var$pageLoadCommon
];
const $636bb42aae64c21e$var$pageSegmentLoadSet = [
    ...$636bb42aae64c21e$var$defaultSet,
    (0, $daEdN.pageSegmentLoadMetrics),
    (0, $dnamH.pageVisibleState),
    (0, $k5i61.pageVisibleValue),
    (0, $dCIsG.eventInitial),
    (0, $4tc5v.bundleEvalTimings)
];
const $636bb42aae64c21e$var$interactionSet = [
    ...$636bb42aae64c21e$var$defaultSet,
    (0, $dnamH.pageVisibleState),
    (0, $k5i61.pageVisibleValue),
    (0, $5z4jj.interactionMetrics)
];
const $636bb42aae64c21e$var$customMetricSet = [
    ...$636bb42aae64c21e$var$defaultSet,
    (0, $dnamH.pageVisibleState),
    (0, $k5i61.pageVisibleValue),
    (0, $gMSq9.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $636bb42aae64c21e$var$webVitalsMetricSet = [
    ...$636bb42aae64c21e$var$defaultSet,
    (0, $2zJKD.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $636bb42aae64c21e$var$waitForCLS = (delay = (0, $aYK1g.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $636bb42aae64c21e$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $7aLI7.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $4pWCS.BMEventsType).PAGE_LOAD && (0, $1wjYt.isPageLoadMetricData)(data) && data.isInitial) set = $636bb42aae64c21e$var$initialPageLoadSet;
    if (data.config.type === (0, $4pWCS.BMEventsType).PAGE_LOAD && (0, $1wjYt.isPageLoadMetricData)(data) && !data.isInitial) set = $636bb42aae64c21e$var$spaTransitionSet;
    if (data.config.type === (0, $4pWCS.BMEventsType).PAGE_SEGMENT_LOAD && (0, $1wjYt.isPageSegmentLoadMetricData)(data)) set = $636bb42aae64c21e$var$pageSegmentLoadSet;
    if (data.config.type === (0, $4pWCS.BMEventsType).INLINE_RESULT) set = $636bb42aae64c21e$var$interactionSet;
    if (data.config.type === (0, $4pWCS.BMEventsType).CUSTOM) set = $636bb42aae64c21e$var$customMetricSet;
    if (data.config.type === (0, $4pWCS.BMEventsType).WEB_VITALS) {
        set = $636bb42aae64c21e$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $636bb42aae64c21e$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("1wjYt", function(module, exports) {

$parcel$export(module.exports, "isPageLoadMetricData", () => $50cb16d65ef746ad$export$b0e12e7abb0bff11);
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $50cb16d65ef746ad$export$83d0099ee6dbb5b0);
$parcel$export(module.exports, "isPageLoadConfig", () => $50cb16d65ef746ad$export$8672fa27ba8bba88);
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $50cb16d65ef746ad$export$abe063537ef4987b);
$parcel$export(module.exports, "isInteractionConfig", () => $50cb16d65ef746ad$export$ae68674b6a9353be);
$parcel$export(module.exports, "isCustomConfig", () => $50cb16d65ef746ad$export$b493eb8b2ba87421);

var $4pWCS = parcelRequire("4pWCS");
const $50cb16d65ef746ad$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $4pWCS.BMEventsType).PAGE_LOAD;
};
const $50cb16d65ef746ad$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $4pWCS.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $50cb16d65ef746ad$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $4pWCS.BMEventsType).PAGE_LOAD;
};
const $50cb16d65ef746ad$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $4pWCS.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $50cb16d65ef746ad$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $4pWCS.BMEventsType).INLINE_RESULT;
};
const $50cb16d65ef746ad$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $4pWCS.BMEventsType).CUSTOM;
};

});

parcelRegister("37Uoz", function(module, exports) {

$parcel$export(module.exports, "appFramework", () => $ec72f2396cabf88f$export$e34e4529b979f74c);
const $ec72f2396cabf88f$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("bjQ1n", function(module, exports) {

$parcel$export(module.exports, "appVersion", () => $6d882fa3a75aa865$export$82ae485178b37419);
const $6d882fa3a75aa865$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("bLJ7U", function(module, exports) {

$parcel$export(module.exports, "bmVersion", () => $c351fd4589e9a5b8$export$5cafa465fc876895);
const $c351fd4589e9a5b8$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("gKKg0", function(module, exports) {

$parcel$export(module.exports, "customData", () => $c0dea797bf519a4c$export$f7e743c7db162193);
const $c0dea797bf519a4c$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("bSYcP", function(module, exports) {

$parcel$export(module.exports, "eventId", () => $dd491644943380bd$export$aed28df7ac07d79a);
const $dd491644943380bd$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("dCIsG", function(module, exports) {

$parcel$export(module.exports, "eventInitial", () => $0a495cd141aeb7af$export$fa8e91d436b3ef8b);

var $1wjYt = parcelRequire("1wjYt");
const $0a495cd141aeb7af$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $1wjYt.isPageLoadMetricData)(data) && !(0, $1wjYt.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("jAlk0", function(module, exports) {

$parcel$export(module.exports, "eventKey", () => $fe74ae57b75cf53d$export$10be2d3a558d3f88);

var $amb9A = parcelRequire("amb9A");
const $fe74ae57b75cf53d$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $amb9A.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("amb9A", function(module, exports) {

$parcel$export(module.exports, "mapEventType", () => $9dd8a52c8062bb59$export$b334d07f11140768);

var $4pWCS = parcelRequire("4pWCS");
const $9dd8a52c8062bb59$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $4pWCS.BMEventsType).CUSTOM:
            return (0, $4pWCS.StorableBMEventsType).CUSTOM;
        case (0, $4pWCS.BMEventsType).INLINE_RESULT:
            return (0, $4pWCS.StorableBMEventsType).INLINE_RESULT;
        case (0, $4pWCS.BMEventsType).PAGE_LOAD:
            return (0, $4pWCS.StorableBMEventsType).PAGE_LOAD;
        case (0, $4pWCS.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $4pWCS.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $4pWCS.BMEventsType).WEB_VITALS:
            return (0, $4pWCS.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("SgPTv", function(module, exports) {

$parcel$export(module.exports, "eventLocalTime", () => $99a3da3f9e2ec08d$export$5219854ae7ec45da);

var $k7m40 = parcelRequire("k7m40");
const $99a3da3f9e2ec08d$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $k7m40.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $k7m40.default)(new Date(), 'i'), 10)
    });

});

parcelRegister("3H6M8", function(module, exports) {

$parcel$export(module.exports, "eventProduct", () => $c15952df4dc79bc4$export$a7df4e8088db8843);
const $c15952df4dc79bc4$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("dOcKt", function(module, exports) {

$parcel$export(module.exports, "eventRegion", () => $6be05715ee2f823f$export$d0117b71adcdebc0);
const $6be05715ee2f823f$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("kKTdf", function(module, exports) {

$parcel$export(module.exports, "eventRoute", () => $011bab2312eba4cc$export$44d3627af289ca16);
const $011bab2312eba4cc$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("i73iw", function(module, exports) {

$parcel$export(module.exports, "eventType", () => $63e5171dc0815632$export$4c045e605d532c98);

var $amb9A = parcelRequire("amb9A");
const $63e5171dc0815632$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $amb9A.mapEventType)(config.type)
    };
};

});

parcelRegister("cZQQm", function(module, exports) {

$parcel$export(module.exports, "featureFlags", () => $2915492e953391b1$export$e62953d023125748);
const $2915492e953391b1$export$e62953d023125748 = (config, _data, globalConfig)=>{
    const localFeatureFlags = config.featureFlags?.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {}) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("7KbFk", function(module, exports) {

$parcel$export(module.exports, "hostname", () => $f406cf2e6bf2daf8$export$640106f6dc7d2706);
const $f406cf2e6bf2daf8$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("gMSq9", function(module, exports) {

$parcel$export(module.exports, "customEventMetrics", () => $59d0edbf5fbf2827$export$cab039265c52a2e9);

var $1wjYt = parcelRequire("1wjYt");
const $59d0edbf5fbf2827$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    if (!(0, $1wjYt.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (config.slo?.threshold !== undefined) {
        payload['metric:duration:slo'] = payload['metric:duration'] <= config.slo?.threshold;
        payload['metric:duration:slo:threshold'] = config.slo?.threshold;
    }
    if (config.histogram?.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("48rs6", function(module, exports) {

$parcel$export(module.exports, "initialPageLoadMetrics", () => $f1efa9ba6f086718$export$cc95aa3f6ea8e5cb);
const $f1efa9ba6f086718$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("5z4jj", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", () => $9315acf3040459eb$export$86db56030b57ba34);

var $1wjYt = parcelRequire("1wjYt");

var $4pWCS = parcelRequire("4pWCS");
const $9315acf3040459eb$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    if (!(0, $1wjYt.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if (config.histogram?.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $4pWCS.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $4pWCS.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if (config.histogram?.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $4pWCS.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $4pWCS.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $4pWCS.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("7Etaq", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", () => $462fa7a1803c2500$export$b88d990436be0f8a);
const $462fa7a1803c2500$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("2jaQ3", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", () => $b35dcbd6d2081d96$export$2878bf482e539059);

var $1wjYt = parcelRequire("1wjYt");

var $4pWCS = parcelRequire("4pWCS");
const $b35dcbd6d2081d96$var$getThreshold = (isInitial, metric)=>{
    return (0, $4pWCS.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $b35dcbd6d2081d96$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $b35dcbd6d2081d96$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $1wjYt.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $4pWCS.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $b35dcbd6d2081d96$var$getHistogram(data.isInitial, (0, $4pWCS.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $b35dcbd6d2081d96$var$getHistogram(data.isInitial, (0, $4pWCS.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $b35dcbd6d2081d96$var$getHistogram(data.isInitial, (0, $4pWCS.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $b35dcbd6d2081d96$var$getHistogram(data.isInitial, (0, $4pWCS.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $b35dcbd6d2081d96$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $b35dcbd6d2081d96$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});

parcelRegister("daEdN", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $9265c3617ea6829a$export$ba86cb47f2f22db5);

var $9EfFg = parcelRequire("9EfFg");

var $1wjYt = parcelRequire("1wjYt");

var $4pWCS = parcelRequire("4pWCS");
const $9265c3617ea6829a$var$getThreshold = (isInitial, metric)=>{
    return (0, $4pWCS.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $9265c3617ea6829a$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $9265c3617ea6829a$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    if (!(0, $1wjYt.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $4pWCS.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $9265c3617ea6829a$var$getHistogram(data.isInitial, (0, $4pWCS.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $9265c3617ea6829a$var$getHistogram(data.isInitial, (0, $4pWCS.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $9265c3617ea6829a$var$getHistogram(data.isInitial, (0, $4pWCS.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $9265c3617ea6829a$var$getHistogram(data.isInitial, (0, $4pWCS.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if (config.slo?.fmp) {
        const threshold = $9265c3617ea6829a$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo?.tti) {
        const threshold = $9265c3617ea6829a$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $4pWCS.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $4pWCS.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $9EfFg.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $4pWCS.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("2zJKD", function(module, exports) {

$parcel$export(module.exports, "webVitalsMetrics", () => $2cc7dd3b7a44c48c$export$3731db279f590f30);

var $c4cEO = parcelRequire("c4cEO");

var $gm6y9 = parcelRequire("gm6y9");

var $ijz4N = parcelRequire("ijz4N");

var $k5i61 = parcelRequire("k5i61");
const $2cc7dd3b7a44c48c$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $c4cEO.PageVisibleState).MIXED;
    };
    (0, $gm6y9.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
    const webVitalMetrics = await $2cc7dd3b7a44c48c$export$193ae490b52081dd(ttciEnabled, globalConfig.webVitals?.timeout || 30000);
    (0, $gm6y9.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $k5i61.pageVisibleValue)(config, data, globalConfig)
    };
};
const $2cc7dd3b7a44c48c$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $ijz4N.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $ijz4N.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $ijz4N.webVitalsObserver).data;
};

});
parcelRegister("k5i61", function(module, exports) {

$parcel$export(module.exports, "pageVisibleValue", () => $36f3185709718820$export$177b923114656380);

var $c4cEO = parcelRequire("c4cEO");
var $4pWCS = parcelRequire("4pWCS");
const $36f3185709718820$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $4pWCS.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $c4cEO.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});


parcelRegister("dnamH", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", () => $f11bfd78dc93e2fd$export$723b4c298aca63af);
const $f11bfd78dc93e2fd$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("6Dxf3", function(module, exports) {

$parcel$export(module.exports, "productCustomData", () => $1000e87966e37c8d$export$fa2af6e412815a74);
const $1000e87966e37c8d$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("9b69F", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", () => $6bb877a18f00e7d6$export$fdbea518c19dfa8);

var $4pWCS = parcelRequire("4pWCS");
const $6bb877a18f00e7d6$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $6bb877a18f00e7d6$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    // no config or missing
    if (!globalConfig.ssr?.getFeatureFlags) return null;
    const includeFeatureFlags = config.ssr?.includeFeatureFlags || globalConfig.ssr?.includeFeatureFlags || (0, $4pWCS.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $4pWCS.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || config.ssr?.doneAsFmp && includeFeatureFlags === (0, $4pWCS.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $6bb877a18f00e7d6$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("dE6Wc", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", () => $da7cc981fd1c85ca$export$a3dc8251cf55b2e0);
const $da7cc981fd1c85ca$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("b87QT", function(module, exports) {

$parcel$export(module.exports, "telemetryBrowser", () => $32f35a0617c6f78a$export$386b10ac64a50b1);

var $4XKM3 = parcelRequire("4XKM3");
const $32f35a0617c6f78a$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});

parcelRegister("6ZQkL", function(module, exports) {

$parcel$export(module.exports, "telemetryCpu", () => $5fbb62b97736abb0$export$9f84cb359ed29139);
const $5fbb62b97736abb0$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("87NA1", function(module, exports) {

$parcel$export(module.exports, "telemetryMemory", () => $51e930d8a2b8c0fa$export$496c14d72b257e07);
const $51e930d8a2b8c0fa$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("1p0BT", function(module, exports) {

$parcel$export(module.exports, "telemetryNetwork", () => $bccd3c87210e5c73$export$88bf7b55f7fc4e8e);
const $bccd3c87210e5c73$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("bFBnq", function(module, exports) {

$parcel$export(module.exports, "appTimings", () => $a2064b36af82888a$export$e952f50a4f2d02da);

var $4pWCS = parcelRequire("4pWCS");

var $1g0Pv = parcelRequire("1g0Pv");

var $l882E = parcelRequire("l882E");
const $a2064b36af82888a$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $4pWCS.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $1g0Pv.customTimings)(config, data);
    const ssr = config.type === (0, $4pWCS.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $l882E.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("1g0Pv", function(module, exports) {

$parcel$export(module.exports, "customTimings", () => $0a3274042706c241$export$6126f85083a72c6e);

const $0a3274042706c241$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $0a3274042706c241$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $0a3274042706c241$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $0a3274042706c241$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $1c7bef6b14449338$export$b98e411ae80c806f)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
const $1c7bef6b14449338$export$b98e411ae80c806f = '/';


parcelRegister("l882E", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", () => $c2fa6203c8e96ded$export$130f411261a599c5);

const $c2fa6203c8e96ded$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $c2fa6203c8e96ded$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $c2fa6203c8e96ded$var$SSR_PREFIX = 'ssr';
const $c2fa6203c8e96ded$var$mapKey = (key)=>{
    if (key === 'total') return $c2fa6203c8e96ded$var$SSR_PREFIX;
    return `${$c2fa6203c8e96ded$var$SSR_PREFIX}${0, $1c7bef6b14449338$export$b98e411ae80c806f}${key}`;
};
const $c2fa6203c8e96ded$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($c2fa6203c8e96ded$var$filterEntry(entry[1])) acc[$c2fa6203c8e96ded$var$mapKey(entry[0])] = $c2fa6203c8e96ded$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("4tc5v", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $891427c3d3fdabd7$export$1a2bb347935fc536);
const $891427c3d3fdabd7$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = globalConfig?.enableBundleEvalTimings ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $891427c3d3fdabd7$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($891427c3d3fdabd7$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("5IjYB", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", () => $f2084fead5c25790$export$81a7d52441a06b50);
const $f2084fead5c25790$var$cacheableTypes = [
    'script',
    'link'
];
const $f2084fead5c25790$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $f2084fead5c25790$var$CACHE_NETWORK = 'network';
const $f2084fead5c25790$var$CACHE_MEMORY = 'memory';
const $f2084fead5c25790$var$CACHE_DISK = 'disk';
const $f2084fead5c25790$var$calculateTransferType = (type, duration, size)=>{
    if (!$f2084fead5c25790$var$cacheableTypes.includes(type)) return $f2084fead5c25790$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $f2084fead5c25790$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $f2084fead5c25790$var$CACHE_DISK;
    if (size === undefined) return null;
    return $f2084fead5c25790$var$CACHE_NETWORK;
};
const $f2084fead5c25790$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$f2084fead5c25790$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $f2084fead5c25790$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $f2084fead5c25790$var$withoutHeaders = ()=>false;
const $f2084fead5c25790$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $f2084fead5c25790$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $f2084fead5c25790$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $f2084fead5c25790$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $f2084fead5c25790$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $f2084fead5c25790$var$getNetworkData = (item, eventStart, hasTimingHeaders = $f2084fead5c25790$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$f2084fead5c25790$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($f2084fead5c25790$var$cacheableTypes.includes(type)) {
        const transferType = $f2084fead5c25790$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$f2084fead5c25790$var$getSizeObject(size)
        };
        if (transferType !== $f2084fead5c25790$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$f2084fead5c25790$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$f2084fead5c25790$var$getSizeObject(size)
    };
};
const $f2084fead5c25790$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $f2084fead5c25790$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $f2084fead5c25790$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$f2084fead5c25790$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$f2084fead5c25790$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});


parcelRegister("iaf4x", function(module, exports) {

$parcel$export(module.exports, "makeShareableGlobalConfig", () => $2d2e8c9af1322128$export$5b4fb14409a2a825);

var $4pWCS = parcelRequire("4pWCS");
const $2d2e8c9af1322128$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $2d2e8c9af1322128$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = eventConfig?.pageVisibleValueOrigin ?? allEventsConfig?.pageVisibleValueOrigin ?? (0, $4pWCS.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($2d2e8c9af1322128$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig?.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig?.enableBundleEvalTimings
    });
};
const $2d2e8c9af1322128$export$5b4fb14409a2a825 = async (globalConfig)=>{
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: globalConfig.events[(0, $4pWCS.BMEventsType).WEB_VITALS]?.enabled,
            timeout: globalConfig.events[(0, $4pWCS.BMEventsType).WEB_VITALS]?.timeout,
            ttciEnabled: globalConfig.events[(0, $4pWCS.BMEventsType).WEB_VITALS]?.ttciEnabled
        }
    };
    return {
        [(0, $4pWCS.BMEventsType).PAGE_LOAD]: $2d2e8c9af1322128$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $4pWCS.BMEventsType).PAGE_LOAD]),
        [(0, $4pWCS.BMEventsType).PAGE_SEGMENT_LOAD]: $2d2e8c9af1322128$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $4pWCS.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $4pWCS.BMEventsType).INLINE_RESULT]: $2d2e8c9af1322128$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $4pWCS.BMEventsType).INLINE_RESULT]),
        [(0, $4pWCS.BMEventsType).CUSTOM]: $2d2e8c9af1322128$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $4pWCS.BMEventsType).CUSTOM]),
        [(0, $4pWCS.BMEventsType).WEB_VITALS]: $2d2e8c9af1322128$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $4pWCS.BMEventsType).WEB_VITALS])
    };
};

});



parcelRegister("lc02l", function(module, exports) {

$parcel$export(module.exports, "ufologger", () => $ab77af7921c8db01$export$4ab84f6f04f6566d);
$parcel$export(module.exports, "ufolog", () => $ab77af7921c8db01$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $ab77af7921c8db01$export$d53d07b6034c4560);
class $ab77af7921c8db01$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($ab77af7921c8db01$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($ab77af7921c8db01$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $ab77af7921c8db01$export$4ab84f6f04f6566d = new $ab77af7921c8db01$var$UFOLogger();
const $ab77af7921c8db01$export$b4958caff08a0960 = (...args)=>{
    $ab77af7921c8db01$export$4ab84f6f04f6566d.log(...args);
};
const $ab77af7921c8db01$export$d53d07b6034c4560 = (...args)=>{
    $ab77af7921c8db01$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("cKCI2", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $a504d27818fcaf67$export$15e172712955e18f);
const $a504d27818fcaf67$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});

parcelRegister("kuu3B", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $bb02de555e7a62b2$export$6123a44dc2384540);
$parcel$export(module.exports, "setGlobalEventStream", () => $bb02de555e7a62b2$export$c1522520b417b066);
$parcel$export(module.exports, "subscribeEvent", () => $bb02de555e7a62b2$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $bb02de555e7a62b2$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $bb02de555e7a62b2$export$7c957416596ca127);

var $lc02l = parcelRequire("lc02l");

var $bNnqm = parcelRequire("bNnqm");
const $bb02de555e7a62b2$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $bb02de555e7a62b2$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $bb02de555e7a62b2$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $bb02de555e7a62b2$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $lc02l.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $bb02de555e7a62b2$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $bNnqm.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $bb02de555e7a62b2$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $bNnqm.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $bb02de555e7a62b2$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $bNnqm.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("bNnqm", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $b7c7bbb443b28996$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $b7c7bbb443b28996$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $b7c7bbb443b28996$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $b7c7bbb443b28996$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $b7c7bbb443b28996$export$837e0f79a8056912);
var $b7c7bbb443b28996$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $b7c7bbb443b28996$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $b7c7bbb443b28996$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $b7c7bbb443b28996$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $b7c7bbb443b28996$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $b7c7bbb443b28996$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $b7c7bbb443b28996$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $b7c7bbb443b28996$export$9f2bf58999404c75 = 'fmp';
const $b7c7bbb443b28996$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("fuhom", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $457fb25b7c8e1f63$export$13e680397ec8f3eb);

var $cKCI2 = parcelRequire("cKCI2");
class $457fb25b7c8e1f63$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $cKCI2.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $457fb25b7c8e1f63$export$13e680397ec8f3eb = new $457fb25b7c8e1f63$var$VisibilityChangeObserver();

});

parcelRegister("ivxS0", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $4d23a8264e582891$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $4d23a8264e582891$export$cc26007c03242fff);
var $4d23a8264e582891$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $4d23a8264e582891$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("pqe1N", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("3g5n0")).default);

var $3g5n0 = parcelRequire("3g5n0");

var $8lKAp = parcelRequire("8lKAp");

});
parcelRegister("3g5n0", function(module, exports) {

$parcel$export(module.exports, "default", () => $76961587ca25ca9d$export$2e2bcd8739ae039);

var $8lKAp = parcelRequire("8lKAp");

var $kkMJj = parcelRequire("kkMJj");

var $hIAbw = parcelRequire("hIAbw");

var $6UV3s = parcelRequire("6UV3s");
class $76961587ca25ca9d$export$2e2bcd8739ae039 {
    constructor(options){
        (0, $kkMJj.enforceAttributes)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
    setFlags(flags) {
        if (!(0, $kkMJj.isObject)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
	 * This method returns the wrapper object for the given flag key.
	 * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
	 * so it is always guaranteed to return an object.
	 */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $6UV3s.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $hIAbw.default)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $kkMJj.enforceAttributes)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $kkMJj.enforceAttributes)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $kkMJj.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $kkMJj.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
	 * This method combines both the trackExposure and sendAutomaticExposure flows into
	 * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
	 * is sent.
	 **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $8lKAp.ExposureTriggerReason).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $8lKAp.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $8lKAp.ExposureTriggerReason).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $kkMJj.checkForReservedAttributes)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $kkMJj.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $8lKAp.ExposureTriggerReason).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $kkMJj.isObjectEmptyOrUndefined)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $8lKAp.ExposureTriggerReason).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
}

});
parcelRegister("8lKAp", function(module, exports) {

$parcel$export(module.exports, "ExposureTriggerReason", () => $05f65e16cd15c89b$export$2c20ffeba7dbc068);
var $05f65e16cd15c89b$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});

});

parcelRegister("kkMJj", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $5a0c359bdd04f713$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectEmptyOrUndefined", () => $5a0c359bdd04f713$export$8ed1df9dbe2e9a7d);
$parcel$export(module.exports, "enforceAttributes", () => $5a0c359bdd04f713$export$c7d37910dd25ecbf);
$parcel$export(module.exports, "checkForReservedAttributes", () => $5a0c359bdd04f713$export$891630e169ca14a4);
const $5a0c359bdd04f713$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $5a0c359bdd04f713$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $5a0c359bdd04f713$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $5a0c359bdd04f713$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $5a0c359bdd04f713$var$validateFlag = (flagKey, flag)=>{
    if ($5a0c359bdd04f713$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $5a0c359bdd04f713$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$5a0c359bdd04f713$var$validateFlag(key, flags[key]));
};

});

parcelRegister("hIAbw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8936b1b219f4f8e7$export$2e2bcd8739ae039);
const $8936b1b219f4f8e7$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $8936b1b219f4f8e7$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $8936b1b219f4f8e7$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}

});

parcelRegister("6UV3s", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1aaa94af17c24fd$export$2e2bcd8739ae039);

var $8lKAp = parcelRequire("8lKAp");
class $d1aaa94af17c24fd$export$2e2bcd8739ae039 {
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $8lKAp.ExposureTriggerReason).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $8lKAp.ExposureTriggerReason).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
}

});



parcelRegister("8cWTy", function(module, exports) {

$parcel$export(module.exports, "payloadPublisher", () => $fa0610d61bf8a85c$export$edb879ae55bb9be3);

var $ivxS0 = parcelRequire("ivxS0");
var $fuhom = parcelRequire("fuhom");

var $kuu3B = parcelRequire("kuu3B");

var $lc02l = parcelRequire("lc02l");

var $bNnqm = parcelRequire("bNnqm");


var $79pLj = parcelRequire("79pLj");

var $hWJQG = parcelRequire("hWJQG");

var $2kkzf = parcelRequire("2kkzf");

var $gBFrv = parcelRequire("gBFrv");

var $g3BOo = parcelRequire("g3BOo");

var $3YHyT = parcelRequire("3YHyT");

var $lp2Jt = parcelRequire("lp2Jt");

var $jMmrT = parcelRequire("jMmrT");

var $eFmou = parcelRequire("eFmou");

var $bNZ8Z = parcelRequire("bNZ8Z");

var $12hyt = parcelRequire("12hyt");

var $k4a9B = parcelRequire("k4a9B");

var $6HZWn = parcelRequire("6HZWn");

var $8SSGR = parcelRequire("8SSGR");

var $9k7x4 = parcelRequire("9k7x4");

var $2G98Y = parcelRequire("2G98Y");

var $jESP6 = parcelRequire("jESP6");
const $fa0610d61bf8a85c$var$UNKNOWN_VALUE = 'unknown';
const $fa0610d61bf8a85c$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $fa0610d61bf8a85c$var$UNKNOWN_VALUE,
    id: $fa0610d61bf8a85c$var$UNKNOWN_VALUE,
    uuid: $fa0610d61bf8a85c$var$UNKNOWN_VALUE,
    state: {
        id: $fa0610d61bf8a85c$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $ivxS0.ExperienceTypes).Experience,
    category: $fa0610d61bf8a85c$var$UNKNOWN_VALUE,
    performanceType: (0, $ivxS0.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $bNnqm.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $fa0610d61bf8a85c$var$Publisher {
    publish(data) {
        const payloadStart = (0, $jESP6.getPerformanceObject)()?.now() || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $lc02l.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$fa0610d61bf8a85c$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $8df07907b308e908$export$93809551debf385f) || $fa0610d61bf8a85c$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $jMmrT.eventBrowserPlugin)(),
                    ...(0, $eFmou.eventCpusPlugin)(),
                    ...(0, $12hyt.eventMemoryPlugin)(),
                    ...(0, $k4a9B.eventNetworkPlugin)(),
                    ...(0, $3YHyT.appFramework)(this.app),
                    ...(0, $lp2Jt.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $79pLj.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $gBFrv.pageVisibleState)(supportedData),
                    ...(0, $2G98Y.isInitialPageLoad)(supportedData) && (0, $8SSGR.ssrSuccess)(this.ssr),
                    ...(0, $2G98Y.isInitialPageLoad)(supportedData) && (0, $6HZWn.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $bNZ8Z.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: this.getPerformanceMetrics(supportedData),
                task: supportedData.id
            }
        };
        const payloadEnd = (0, $jESP6.getPerformanceObject)()?.now() || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $lc02l.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $kuu3B.getGlobalEventStream)() instanceof (0, $hWJQG.UFOGlobalEventStream))) {
            const eventStream = new (0, $hWJQG.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $bNnqm.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $kuu3B.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $fuhom.visibilityChangeObserver).start();
        (0, $g3BOo.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $2kkzf.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $fa0610d61bf8a85c$var$UNKNOWN_VALUE;
        this.hostname = (0, $jESP6.getWindowObject)()?.location?.hostname || '';
        this.tenantType = (0, $79pLj.TenantType).RealUser;
        this.app = {
            version: {
                web: $fa0610d61bf8a85c$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $9k7x4.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $fa0610d61bf8a85c$export$edb879ae55bb9be3 = new $fa0610d61bf8a85c$var$Publisher();

});
// temp solution until a proper versioning
const $8df07907b308e908$export$93809551debf385f = '0.1.7';

parcelRegister("79pLj", function(module, exports) {

$parcel$export(module.exports, "TenantType", () => $75fc7af9837a3d3c$export$92a757ac1398962f);

var $75fc7af9837a3d3c$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("hWJQG", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStream", () => $f009d63961b63750$export$faf4c91b80fc830e);

var $lc02l = parcelRequire("lc02l");

var $bNnqm = parcelRequire("bNnqm");
class $f009d63961b63750$export$faf4c91b80fc830e {
    push(event) {
        (0, $lc02l.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $bNnqm.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $bNnqm.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $bNnqm.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        if (this.subscribers[0, $bNnqm.SUBSCRIBE_ALL]) this.subscribers[0, $bNnqm.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        this.subscribers[eventPayload.id]?.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $lc02l.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("2kkzf", function(module, exports) {

$parcel$export(module.exports, "getPerformancePayload", () => $ab04666730ceeb33$export$738d24377baf6a5e);

var $ivxS0 = parcelRequire("ivxS0");

var $bNnqm = parcelRequire("bNnqm");

var $2G98Y = parcelRequire("2G98Y");

var $4wbXT = parcelRequire("4wbXT");

var $h5zza = parcelRequire("h5zza");

var $jcH6O = parcelRequire("jcH6O");

var $gpPFj = parcelRequire("gpPFj");
const $ab04666730ceeb33$var$LoadMetricKeys = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};
const $ab04666730ceeb33$var$InlineResultMetricKeys = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};
const $ab04666730ceeb33$var$CustomMetricKeys = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};
const $ab04666730ceeb33$var$getHistogram = (data, performanceConfig, isInitial)=>{
    let histogram = {};
    if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $ivxS0.ExperiencePerformanceTypes).PageLoad:
            case (0, $ivxS0.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [$ab04666730ceeb33$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                    [$ab04666730ceeb33$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $ivxS0.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [$ab04666730ceeb33$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                    [$ab04666730ceeb33$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                } : {};
            case (0, $ivxS0.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [$ab04666730ceeb33$var$CustomMetricKeys.durationHistograms]: histograms.duration
                } : {};
        }
    }
};
const $ab04666730ceeb33$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, $bNnqm.FMP_MARK))?.time || (0, $2G98Y.isInitialPageLoad)(data) && ssr?.getDoneMark();
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [$ab04666730ceeb33$var$LoadMetricKeys.tti]: Math.round(tti),
        [$ab04666730ceeb33$var$LoadMetricKeys.fmp]: Math.round(fmp),
        ...$ab04666730ceeb33$var$getHistogram(data, performanceConfig)
    };
};
const $ab04666730ceeb33$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $bNnqm.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [$ab04666730ceeb33$var$InlineResultMetricKeys.result]: Math.round(result),
        [$ab04666730ceeb33$var$InlineResultMetricKeys.response]: Math.round(response),
        ...$ab04666730ceeb33$var$getHistogram(data, performanceConfig)
    };
};
const $ab04666730ceeb33$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [$ab04666730ceeb33$var$CustomMetricKeys.duration]: Math.round(duration),
        ...$ab04666730ceeb33$var$getHistogram(data, performanceConfig)
    };
};
const $ab04666730ceeb33$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $ivxS0.ExperiencePerformanceTypes).PageLoad:
        case (0, $ivxS0.ExperiencePerformanceTypes).PageSegmentLoad:
            return $ab04666730ceeb33$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $ivxS0.ExperiencePerformanceTypes).InlineResult:
            return $ab04666730ceeb33$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $ivxS0.ExperiencePerformanceTypes).Custom:
            return $ab04666730ceeb33$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
const $ab04666730ceeb33$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$ab04666730ceeb33$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $gpPFj.resourceTimings)(data, resourceConfig),
        ...(0, $jcH6O.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $h5zza.appTimings)(data, ssr),
        ...(0, $2G98Y.isInitialPageLoad)(data) ? (0, $4wbXT.navigationMetrics)() : null
    };
};

});
parcelRegister("2G98Y", function(module, exports) {

$parcel$export(module.exports, "isInitialPageLoad", () => $1ccdd71cc6a5a59d$export$7167d96e9881d500);

var $ivxS0 = parcelRequire("ivxS0");
const $1ccdd71cc6a5a59d$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $ivxS0.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("4wbXT", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", () => $3c17395201daa3bd$export$b88d990436be0f8a);
const $3c17395201daa3bd$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("h5zza", function(module, exports) {

$parcel$export(module.exports, "appTimings", () => $3657bb17c61f3c48$export$e952f50a4f2d02da);

var $ivxS0 = parcelRequire("ivxS0");

var $2G98Y = parcelRequire("2G98Y");

var $l1oep = parcelRequire("l1oep");

var $8cvje = parcelRequire("8cvje");
const $3657bb17c61f3c48$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $ivxS0.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $l1oep.customTimings)(data);
    const ssr = (0, $2G98Y.isInitialPageLoad)(data) ? (0, $8cvje.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("l1oep", function(module, exports) {

$parcel$export(module.exports, "customTimings", () => $a004f2a9a12a7848$export$6126f85083a72c6e);
const $a004f2a9a12a7848$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $a004f2a9a12a7848$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $a004f2a9a12a7848$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("8cvje", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", () => $5ca41092608ac12c$export$130f411261a599c5);

const $5ca41092608ac12c$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $5ca41092608ac12c$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $5ca41092608ac12c$var$SSR_PREFIX = 'ssr';
const $5ca41092608ac12c$var$mapKey = (key)=>{
    if (key === 'total') return $5ca41092608ac12c$var$SSR_PREFIX;
    return `${$5ca41092608ac12c$var$SSR_PREFIX}${0, $1870f5601b37cfcb$export$b98e411ae80c806f}${key}`;
};
const $5ca41092608ac12c$export$130f411261a599c5 = (ssr)=>{
    if (!ssr?.getTimings) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($5ca41092608ac12c$var$filterEntry(entry[1])) acc[$5ca41092608ac12c$var$mapKey(entry[0])] = $5ca41092608ac12c$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
const $1870f5601b37cfcb$export$b98e411ae80c806f = '/';



parcelRegister("jcH6O", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $28ee603b732877a8$export$1a2bb347935fc536);

var $jESP6 = parcelRequire("jESP6");
const $28ee603b732877a8$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $jESP6.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("jESP6", function(module, exports) {

$parcel$export(module.exports, "getWindowObject", () => $b5b560e05ca8467d$export$9aa44f85591248d9);
$parcel$export(module.exports, "getPerformanceObject", () => $b5b560e05ca8467d$export$8cd0c777b0eb66a0);
$parcel$export(module.exports, "getPerformanceObserverObject", () => $b5b560e05ca8467d$export$74560fd4e61fd440);
const $b5b560e05ca8467d$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
const $b5b560e05ca8467d$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = $b5b560e05ca8467d$export$9aa44f85591248d9() || {};
    return performance;
};
const $b5b560e05ca8467d$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = $b5b560e05ca8467d$export$9aa44f85591248d9() || {};
    return PerformanceObserver;
};

});


parcelRegister("gpPFj", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", () => $ee3672e5d6ceeae3$export$81a7d52441a06b50);

var $jESP6 = parcelRequire("jESP6");

var $g3BOo = parcelRequire("g3BOo");
const $ee3672e5d6ceeae3$var$cacheableTypes = [
    'script',
    'link'
];
const $ee3672e5d6ceeae3$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $ee3672e5d6ceeae3$var$CACHE_NETWORK = 'network';
const $ee3672e5d6ceeae3$var$CACHE_MEMORY = 'memory';
const $ee3672e5d6ceeae3$var$CACHE_DISK = 'disk';
const $ee3672e5d6ceeae3$var$calculateTransferType = (type, duration, size)=>{
    if (!$ee3672e5d6ceeae3$var$cacheableTypes.includes(type)) return $ee3672e5d6ceeae3$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $ee3672e5d6ceeae3$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $ee3672e5d6ceeae3$var$CACHE_DISK;
    if (size === undefined) return null;
    return $ee3672e5d6ceeae3$var$CACHE_NETWORK;
};
const $ee3672e5d6ceeae3$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$ee3672e5d6ceeae3$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $jESP6.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $ee3672e5d6ceeae3$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $ee3672e5d6ceeae3$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $ee3672e5d6ceeae3$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $ee3672e5d6ceeae3$var$getNetworkData = (item, eventStart, hasTimingHeaders = $ee3672e5d6ceeae3$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$ee3672e5d6ceeae3$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($ee3672e5d6ceeae3$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $ee3672e5d6ceeae3$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$ee3672e5d6ceeae3$var$getSizeObject(transferSize)
        };
        if (transferType !== $ee3672e5d6ceeae3$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$ee3672e5d6ceeae3$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$ee3672e5d6ceeae3$var$getSizeObject(transferSize)
    };
};
const $ee3672e5d6ceeae3$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $jESP6.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
    const resources = (0, $g3BOo.getResourceTimings)(data.result.startTime, performance);
    if (!resources?.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $ee3672e5d6ceeae3$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $ee3672e5d6ceeae3$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$ee3672e5d6ceeae3$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("g3BOo", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $82af598ae6aea2b0$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $82af598ae6aea2b0$export$9eebb59359c2e9e5);
// @flow strict-local

var $lc02l = parcelRequire("lc02l");

var $jESP6 = parcelRequire("jESP6");
const $82af598ae6aea2b0$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $jESP6.getPerformanceObject)(), PerformanceObserver1 = (0, $jESP6.getPerformanceObserverObject)())=>{
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($82af598ae6aea2b0$export$bea963256235a63e.observer) {
            (0, $lc02l.ufologger).warn('Observer is already running');
            return;
        }
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $82af598ae6aea2b0$export$bea963256235a63e.timings = resources.map((resource)=>$82af598ae6aea2b0$export$bea963256235a63e.transformResource(resource));
        $82af598ae6aea2b0$export$bea963256235a63e.observer = new PerformanceObserver1($82af598ae6aea2b0$export$bea963256235a63e.addTimings);
        $82af598ae6aea2b0$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($82af598ae6aea2b0$export$bea963256235a63e.observer) {
            $82af598ae6aea2b0$export$bea963256235a63e.observer.disconnect();
            $82af598ae6aea2b0$export$bea963256235a63e.observer = null;
        }
        $82af598ae6aea2b0$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$82af598ae6aea2b0$export$bea963256235a63e.transformResource(entry));
        const overflow = $82af598ae6aea2b0$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $82af598ae6aea2b0$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $82af598ae6aea2b0$export$bea963256235a63e.maxSize;
            $82af598ae6aea2b0$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $82af598ae6aea2b0$export$bea963256235a63e.timings.push(...entries);
    }
};
const $82af598ae6aea2b0$export$9eebb59359c2e9e5 = (startTime, performance = (0, $jESP6.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$82af598ae6aea2b0$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $82af598ae6aea2b0$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});



parcelRegister("gBFrv", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", () => $cd8ebdba6496e29d$export$723b4c298aca63af);

var $bNnqm = parcelRequire("bNnqm");
const $cd8ebdba6496e29d$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $bNnqm.PageVisibleState).HIDDEN : (0, $bNnqm.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("3YHyT", function(module, exports) {

$parcel$export(module.exports, "appFramework", () => $2dadc5d1b1280a03$export$e34e4529b979f74c);
const $2dadc5d1b1280a03$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("lp2Jt", function(module, exports) {

$parcel$export(module.exports, "appVersion", () => $d307906d3cf0066b$export$82ae485178b37419);
const $d307906d3cf0066b$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("jMmrT", function(module, exports) {

$parcel$export(module.exports, "eventBrowserPlugin", () => $8b7f377ecab7b8d9$export$f435c2789ca334a7);

var $4XKM3 = parcelRequire("4XKM3");

var $8QpSo = parcelRequire("8QpSo");

var $jESP6 = parcelRequire("jESP6");
const $8b7f377ecab7b8d9$export$f435c2789ca334a7 = (0, $8QpSo.default)(()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser((0, $jESP6.getWindowObject)()?.navigator?.userAgent || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("eFmou", function(module, exports) {

$parcel$export(module.exports, "eventCpusPlugin", () => $791a4b748ac329c6$export$db7649b8854107ad);

var $8QpSo = parcelRequire("8QpSo");
const $791a4b748ac329c6$export$db7649b8854107ad = (0, $8QpSo.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("bNZ8Z", function(module, exports) {

$parcel$export(module.exports, "featureFlags", () => $a04e535b75a81864$export$e62953d023125748);
const $a04e535b75a81864$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("12hyt", function(module, exports) {

$parcel$export(module.exports, "eventMemoryPlugin", () => $235b3d7f35c807bd$export$81efaf8414879a1a);

var $8QpSo = parcelRequire("8QpSo");
const $235b3d7f35c807bd$export$81efaf8414879a1a = (0, $8QpSo.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("k4a9B", function(module, exports) {

$parcel$export(module.exports, "eventNetworkPlugin", () => $95fdd53e8901ade2$export$ce1cf816dce1da56);
const $95fdd53e8901ade2$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("6HZWn", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", () => $7bff9360818273c6$export$fdbea518c19dfa8);
const $7bff9360818273c6$export$fdbea518c19dfa8 = (ssr)=>{
    if (!ssr?.getFeatureFlags) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("8SSGR", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", () => $9268623a58fbfca5$export$a3dc8251cf55b2e0);
const $9268623a58fbfca5$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr?.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("9k7x4", function(module, exports) {

$parcel$export(module.exports, "Route", () => $9db7059e456ba323$export$e7b0ac011bb776c6);
const $9db7059e456ba323$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});


const $9b3f3f1b6c447782$export$42f4885608027d0c = 'non_boolean';

const $35cd10c46efb0acb$export$f636b5b56f1d624a = 'Screen';
const $35cd10c46efb0acb$export$9d2de6eebf7462b5 = 'Drawer';
const $35cd10c46efb0acb$export$1171103ea9083ffa = 'Modal';
const $35cd10c46efb0acb$export$cae2783c9279926 = 'InlineDialog';
const $35cd10c46efb0acb$export$d1123261ca8831d2 = 'Dropdown';
const $35cd10c46efb0acb$export$a1562d08625f5d7e = 'UI';
const $35cd10c46efb0acb$export$947dac6c72b26f81 = 'TRACK';
const $35cd10c46efb0acb$export$f1d537d508d2945a = 'SCREEN';
const $35cd10c46efb0acb$export$12346a674644c156 = 'OPERATIONAL';
const $35cd10c46efb0acb$export$2ceccf177fae277c = 'analyticsBridge';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $6937820845d8ec13$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $6252f4c5224b497a$export$a1562d08625f5d7e = 'ui';
const $6252f4c5224b497a$export$947dac6c72b26f81 = 'track';
const $6252f4c5224b497a$export$f1d537d508d2945a = 'screen';
const $6252f4c5224b497a$export$12346a674644c156 = 'operational';
const $6252f4c5224b497a$export$b055de0e665cb20c = 'unknown';

const $eff5fbe8897e5af6$export$cf090d5281b5ae06 = 10000;
const $eff5fbe8897e5af6$export$8575e30be0feb909 = 30000;

const $ae4ba6a02d5dd549$export$3288b14b6745c572 = 204;
const $ae4ba6a02d5dd549$export$c09e7ea0fc79f34f = 409;
const $ae4ba6a02d5dd549$export$974c37534b0191b1 = 503;


$parcel$global.rlb("h0zs6")
//# sourceMappingURL=shared~commons~atlassian~ar.6678689d.js.map
